import { useState } from "react";
import { Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Switch } from "@/components/ui/switch";
import { setKiosk, useKiosk } from "@/lib/kiosk";
import { KioskPinDialog } from "@/components/KioskGuard";

export function KioskCard() {
  const { t } = useApp();
  const { kiosk } = useKiosk();
  const [ask, setAsk] = useState(false);
  const toggle = (on) => { if (on) setKiosk(true); else setAsk(true); };
  return (
    <section className="rounded-2xl bg-white border border-border p-4 space-y-3" data-testid="kiosk-card">
      <h2 className="font-heading text-xl font-bold flex items-center gap-2"><Lock className="w-5 h-5" />{t("kiosk_on")}</h2>
      <label className="flex items-center justify-between gap-3 rounded-xl bg-secondary p-3">
        <span><span className="block text-sm font-bold">{t("kiosk_on")}</span><span className="block text-xs text-muted-foreground">{t("kiosk_desc")}</span></span>
        <Switch checked={kiosk} onCheckedChange={toggle} data-testid="kiosk-toggle" />
      </label>
      <p className="text-xs text-muted-foreground">{t("ra_only_admin")}</p>
      <KioskPinDialog open={ask} onClose={() => setAsk(false)} onOk={() => { setAsk(false); setKiosk(false); }} />
    </section>
  );
}
